import React from 'react';

import { FeatureNotAvailable } from '@/components/atoms/FeatureNotAvailable';
import { useFeatureFlag } from '@/hooks/useFeatureFlags';

interface Props {
  readonly flagKey: string;
  readonly defaultValue?: boolean;
}

export const FeatureFlagged: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactNode => {
  const { flagKey, defaultValue = false } = props;

  const flagValue = useFeatureFlag(flagKey, defaultValue);

  if (flagValue) {
    return props.children;
  }

  return <FeatureNotAvailable />;
};
